import React from 'react';
import AnimatedContainer from 'components/AnimatedContainer';
import css from './GradeImprovementBlock.module.scss';

function GradeImprovementBlock() {
  return (
    <AnimatedContainer>
      <div className={css.mainBlock}>
        <div className={css.wrapper}>
          <h2 className={css.mainTitle}>
            Tutor House only accepts the <span>top 20%</span> of applicants to
            become <span>tutors</span> with us.
          </h2>
        </div>
      </div>
    </AnimatedContainer>
  );
}

export default GradeImprovementBlock;
